import type { BuildInfo } from "@jourfx/types/buildInfo";

const fallbackBuildInfo: BuildInfo = {
  appId: "admin",
  appVersion: "unknown",
  buildId: "admin-unknown+unknown.0",
  gitSha: "unknown",
  shortSha: "unknown",
  builtAt: new Date(0).toISOString(),
  environment: "local",
};

export const buildInfo: BuildInfo =
  typeof __JOURFX_BUILD_INFO__ !== "undefined"
    ? __JOURFX_BUILD_INFO__
    : fallbackBuildInfo;

export function getBuildInfo(): BuildInfo {
  return buildInfo;
}
